// @ts-nocheck
// Set the attributes for each of the accordions
var accordionKnt = 1;
var accordionCardKnt = 1;
var accordionGroup = 0;
jQuery('.dol-accordion').each(function () {
  accordionGroup++;
  jQuery(this).parent().addClass('accordion-group accordion-group-' + accordionGroup);

  var accordionMainId = 'dolAccordion' + accordionKnt;
  var accordionMainIdDataParent = '.dolAccordion' + accordionKnt;
  jQuery(this).addClass(accordionMainId);
  jQuery(this).find('.card-header h5 a').attr('data-parent', accordionMainIdDataParent);

  jQuery(this).find('.card').each(function () {
    var accordionHeaderId = 'dolAccordionHeading' + accordionCardKnt;
    var dolAccordionLinkHref = '.dolAccordionCollapse' + accordionCardKnt;
    var dolAccordionLink = 'dolAccordionCollapse' + accordionCardKnt;
    jQuery(this).find('.card-header').addClass(accordionHeaderId);
    jQuery(this).find('.card-header h5 a').attr('href', dolAccordionLinkHref);
    jQuery(this).find('.card-header h5 a').attr('aria-controls', dolAccordionLink);
    jQuery(this).find('.collapse').addClass(dolAccordionLink);
    jQuery(this).find('.collapse').attr('aria-labelledby', accordionHeaderId);
    jQuery(this).find('.collapse').attr('data-parent', '.accordion-group-' + accordionGroup);

    accordionCardKnt++;
  });
  accordionKnt++;
});

var acc = jQuery('.accordion');
for (var i = 0; i < acc.length; i++) {
  acc[i].addEventListener('click', function() {
    jQuery(this).find('.svg-inline--fa').toggleClass('fa-plus-square fa-minus-square active');
    jQuery(this).parent().find('.panel').toggleClass('active');
  });
}
var coll = jQuery('.paragraph--type--accordion-item .card .card-header h5 a');
for (var i = 0; i < coll.length; i++) {
  coll[i].addEventListener('click', function() {
    jQuery(this).find('.svg-inline--fa').toggleClass('fa-angle-down fa-angle-right');
  });
}
jQuery( window ).resize(function() {
  if(jQuery(window).width() > 951){
    if(jQuery('.accordion').attr('tabindex') != -1){
      jQuery('.accordion').attr('tabindex', -1);
    }
  }
  else{
    if(jQuery('.accordion').attr('tabindex') == -1){
      jQuery('.accordion').attr('tabindex', 0);
    }
  }
});

// Expand First accordion in group by default



// Hide some of the elements by default
// Appended content after to avoid the flicker when there's lag time
jQuery('.field--name-field-bundles, .ilab-collapsible-sections, .ilab-findings-region').each(function () {
  jQuery(this)
    .find('.accordion-group')
    .first()
    .prepend('<div class="panel-toggler"><a href="#" class="expand-all">Expand All</a><span class="accordionExpColDivider">&nbsp;|&nbsp;</span><a href="#" class="collapse-all">Collapse All</a></div>');
});
jQuery('.field--name-field-collapsible-sections').each(function () {
    jQuery(this)
        .find('.accordion-group')
        .first()
        .prepend('<div class="panel-toggler"><a href="#" class="expand-all">Expand All</a><span class="accordionExpColDivider">&nbsp;|&nbsp;</span><a href="#" class="collapse-all">Collapse All</a></div>');
});
// Remove Expand All / Collapse All options when only one accordion
jQuery('.field--name-field-bundles', '.field--name-field-collapsible-sections, .ilab-collapsible-sections, .ilab-findings-region').each(function () {
  jQuery(this).find('.accordion-group:only-child').children('.panel-toggler').remove();
});
jQuery('.field--name-field-collapsible-sections').each(function () {
    jQuery(this).find('.accordion-group:only-child').children('.panel-toggler').remove();
});
// Expand and Collapse all functionality
jQuery('.expand-all').click(function (e) {
  jQuery(this).parent().parent().parent().find('.multi-collapse').collapse('show');
  jQuery(this).parent().parent().parent().find('.svg-inline--fa').removeClass('fa-angle-right').addClass('fa-angle-down');
  e.preventDefault();
});
jQuery('.collapse-all').click(function (e) {
  jQuery(this).parent().parent().parent().find('.multi-collapse').collapse('hide');
  jQuery(this).parent().parent().parent().find('.svg-inline--fa').removeClass('fa-angle-down').addClass('fa-angle-right');
  e.preventDefault();
});

// var compareShown = [];
// var compareHidden = [];
// var visibilityCheck = [];

// jQuery('.field--name-field-bundles').click(function(){
//     visibilityCheck = [];
// 	jQuery(this).find('a[aria-expanded]').each(function(){

// 		visibilityCheck.push(jQuery(this).attr('aria-expanded'))
//     });
// });


// ~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=

// Show/Hide elements after collapsing or expanding a panel
jQuery('.field--name-field-bundles, .ilab-collapsible-sections, .ilab-findings-region').on('hidden.bs.collapse', function () {
  var checkExpanded;
  jQuery(this).find('a[aria-expanded]').each(function (index) {
    if (jQuery(this).attr('aria-expanded') == 'true') {
      checkExpanded = 'true';
    }
  });
  if (checkExpanded == 'true') {
    jQuery(this).find('.expand-all').show();
    jQuery(this).find('.accordionExpColDivider').show();
  } else {
    jQuery(this).find('.expand-all').show();
    jQuery(this).find('.collapse-all').hide();
    jQuery(this).find('.accordionExpColDivider').hide();
  }
});

jQuery('.field--name-field-bundles, .ilab-collapsible-sections, .ilab-findings-region').on('shown.bs.collapse', function () {
  var checkExpanded;
  jQuery(this).find('a[aria-expanded]').each(function (index) {
    if (jQuery(this).attr('aria-expanded') == 'false') {
      checkExpanded = 'false';
    }
  });
  if (checkExpanded == 'false') {
    jQuery(this).find('.collapse-all').show();
    jQuery(this).find('.accordionExpColDivider').show();
  } else {
    jQuery(this).find('.expand-all').hide();
    jQuery(this).find('.collapse-all').show();
    jQuery(this).find('.accordionExpColDivider').hide();
  }
});
jQuery('.field--name-field-collapsible-sections').on('hidden.bs.collapse', function () {
    var checkExpanded;
    jQuery(this).find('a[aria-expanded]').each(function (index) {
        if (jQuery(this).attr('aria-expanded') == 'true') {
            checkExpanded = 'true';
        }
    });
    if (checkExpanded == 'true') {
        jQuery(this).find('.expand-all').show();
        jQuery(this).find('.accordionExpColDivider').show();
    } else {
        jQuery(this).find('.expand-all').show();
        jQuery(this).find('.collapse-all').hide();
        jQuery(this).find('.accordionExpColDivider').hide();
    }
});

jQuery('.field--name-field-collapsible-sections').on('shown.bs.collapse', function () {
    var checkExpanded;
    jQuery(this).find('a[aria-expanded]').each(function (index) {
        if (jQuery(this).attr('aria-expanded') == 'false') {
            checkExpanded = 'false';
        }
    });
    if (checkExpanded == 'false') {
        jQuery(this).find('.collapse-all').show();
        jQuery(this).find('.accordionExpColDivider').show();
    } else {
        jQuery(this).find('.expand-all').hide();
        jQuery(this).find('.collapse-all').show();
        jQuery(this).find('.accordionExpColDivider').hide();
    }
});

// Toggle the panel by selecting the card header
jQuery('.dol-accordion-border .card-header, .dol-accordion-light .card-header, .ilab-accordion .card-header').click(function () {
  jQuery(this).parent().find('.collapse').collapse('toggle');
});

jQuery(document).ready(function () {
  jQuery('div.paragraph--type--accordion-item').parent().parent().css('flex-wrap', 'wrap');
  jQuery('div.paragraph--type--accordion-item').parent().css('flex', '0 0 100%');
  jQuery('div.paragraph--type--ilab-child-labor-report-collapsi').parent().parent().css('flex-wrap', 'wrap');
  jQuery('div.paragraph--type--ilab-child-labor-report-collapsi').parent().css('flex', '0 0 100%');
  jQuery(this).find('.collapse-all').hide();
  jQuery(this).find('.accordionExpColDivider').hide();
});
